
import React, { useState, useEffect } from 'react';
import { useRSVP } from '../../context/RSVPContext';
import { Textarea } from '@/components/ui/textarea';
import { RSVPButton } from '@/components/ui/rsvp-button';
import { Button } from '@/components/ui/button';

export const FeedbackStep = () => {
  const { 
    feedback,
    setFeedback,
    goToNextStep,
    goToPreviousStep,
    eventData,
    selectedGuest,
    rsvpResponse
  } = useRSVP();

  const [localFeedback, setLocalFeedback] = useState(feedback);

  const hostFirstName = eventData?.hostName 
    ? eventData.hostName.split(' ')[0] 
    : 'the host';

  useEffect(() => {
    console.log('FeedbackStep mounted, context feedback value:', feedback);
    setLocalFeedback(feedback);
  }, [feedback]);

  const handleContinue = () => {
    setFeedback(localFeedback);
    goToNextStep();
  };

  const guestName = selectedGuest?.displayName?.split(' ')[0] || 'you';
  
  // Check if this is a resuming an already started RSVP
  const isResumingRSVP = selectedGuest?.claimed && !selectedGuest?.hasResponded;
  
  let feedbackTitle = '';
  
  if (isResumingRSVP) {
    // For resuming RSVPs
    feedbackTitle = `Continuing your RSVP. Any message for ${hostFirstName}?`;
  } else if (rsvpResponse === 'no') {
    // For declining RSVPs
    feedbackTitle = `Sorry you can't make it. Any message for ${hostFirstName}?`;
  } else {
    // For accepting RSVPs
    feedbackTitle = `Any message for ${hostFirstName}?`;
  }

  return (
    <div className="flex flex-col h-full justify-between">
      <div className="flex-1 flex flex-col">
        <div className="h-[30vh] min-h-[120px] max-h-[180px]"></div>
        
        <div className="px-4 md:px-6">
          <div className="max-w-md mx-auto w-full">
            <h2 className="text-2xl font-semibold mb-8 text-center">
              {feedbackTitle}
            </h2>

            <Textarea
              placeholder="Share your thoughts, preferences, banter..."
              className="min-h-[150px] border-muted"
              value={localFeedback}
              onChange={(e) => {
                console.log('Textarea onChange, new value:', e.target.value);
                setLocalFeedback(e.target.value);
              }}
            />
          </div>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 p-4 pb-12 bg-white">
        <div className="max-w-2xl mx-auto px-4 flex flex-col items-center">
          <RSVPButton 
            className="mx-auto block"
            onClick={handleContinue}
          >
            Next
          </RSVPButton>
          
          <Button
            variant="link" 
            className="mt-2 text-sm text-muted-foreground"
            onClick={goToPreviousStep}
          >
            {rsvpResponse === 'no' ? 'Change response' : 'Change dates'}
          </Button>
        </div>
      </div>
    </div>
  );
};
